const steel10 = "#fafafd";
const steel25 = "#f5f6f7";
const steel50 = "#e8e9ee";
const steel100 = "#b7bac9";
const steel200 = "#9599af";
const steel300 = "#646b8a";
const steel400 = "#464e74";
const steel500 = "#182251";
const steel600 = "#161f4a";
const steel700 = "#11183a";
const steel800 = "#0d132d";
const steel900 = "#0a0e22";
const steels = {
  steel10,
  steel25,
  steel50,
  steel100,
  steel200,
  steel300,
  steel400,
  steel500,
  steel600,
  steel700,
  steel800,
  steel900
};
export {
  steels as default,
  steel10,
  steel100,
  steel200,
  steel25,
  steel300,
  steel400,
  steel50,
  steel500,
  steel600,
  steel700,
  steel800,
  steel900
};
//# sourceMappingURL=index.es9.js.map
